import Navbar from '@/components/feature/Navbar';
import TeamSection from '@/pages/home/components/TeamSection';
import CTASection from '@/pages/home/components/CTASection';
import Footer from '@/components/feature/Footer';

export default function TeamPage() {
  return (
    <main>
      <Navbar />
      <div className="h-20"></div>
      <TeamSection />
      <CTASection />
      <Footer />
    </main>
  );
}